import { useSelector } from "store/useSelector";
import { useDispatch } from "react-redux";

import { updateAllVisibleRollup } from "../providers/GlobalStateProvider";
import { addRollups } from "../utils/metrics";
import {
  useProcessesInVisibleGroups,
  useGetPageFromPath,
  useFocusRange,
} from "utils/customHooks/genericHooks";
import { useIsStillLoadingDataToStore } from "pages/DashboardPages/LoadingIndicatorDashboardPages";
import { useEffect, useTransition } from "react";

const AllVisibleRolluper = () => {
  const rollupsMetricByProcess = useSelector(
    state => state.legacy.rollupsMetricByProcess
  );
  const focusRange = useFocusRange();
  const dispatch = useDispatch();
  const { isTrendsPage, isTimelinePage } = useGetPageFromPath();
  const processesInVisibleGroups = useProcessesInVisibleGroups();
  const isStillLoadingData = useIsStillLoadingDataToStore();
  const [, startTransition] = useTransition();

  // combine & dispatch the rollups
  useEffect(() => {
    if (!focusRange || isStillLoadingData) {
      return;
    }
    const shouldCalcPnlCharts = isTimelinePage || isTrendsPage;
    const allProcessesRollupMetric = addRollups(
      rollupsMetricByProcess,
      processesInVisibleGroups
    );
    startTransition(() => {
      dispatch(
        updateAllVisibleRollup(allProcessesRollupMetric, shouldCalcPnlCharts)
      );
    });
  }, [
    isTimelinePage,
    isTrendsPage,
    dispatch,
    focusRange,
    isStillLoadingData,
    processesInVisibleGroups,
    rollupsMetricByProcess,
  ]);
  return null;
};

export default AllVisibleRolluper;
